import {Component, EventEmitter, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  selector: 'app-back-button',
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  template: `
    <app-base-button
      [baseClass]="'rounded-full bg-theme-primary w-10 h-10 flex items-center justify-center text-theme-text3'"
      (onClick)="onClick.emit($event)">
      <i class="fas fa-chevron-left text-md"></i>
    </app-base-button>
  `
})
export class BackButtonComponent {
  @Output() onClick = new EventEmitter<MouseEvent>();
}
